import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "components/common/Link";
import Chip from "@mui/material/Chip";
import { makeStyles } from "@mui/styles";
import Box from "components/common/Box";

const ManufacturerHeading = ({}) => {
  const classes = useStyles();


  return (
    <Stack
      direction={{ sm: "column", xs: "column", md: "row" }}
      spacing={2}
      justifyContent="space-between"
    >
      <Typography variant="h6" color="#707070">
        Manufacturers
      </Typography>

      <Stack
        className={classes.manu}
        direction={{ sm: "column", xs: "column", md: "row" }}
        spacing={1}
      >
        <Box>
          <Link to="/vehicle/manufacturer" style={{ textDecoration: "none" }}>
            <Chip
              className={classes.menuitem}
              label="+ Vehicle Manufacturer"
              sx={{
                alignItems: "center",
                padding: "0 8px",
                backgroundColor: "unset !important ",
                color: "#004AAD",
                border: "1px solid #004AAD",
              }}
            />
          </Link>
        </Box>
        <Link to="/vehicle/model" style={{ textDecoration: "none" }}>
          <Chip
            className={classes.menuitem}
            label=" + Vehicle Model"
            sx={{
              alignItems: "center",
              padding: "0 8px",
              backgroundColor: "unset !important ",
              color: "#004AAD",
              border: "1px solid #004AAD",
            }}
          />
        </Link>
        <Link to="vehicle/Variant" style={{ textDecoration: "none" }}>
          <Chip
            className={classes.menuitem}
            label=" + Vehicle Variant"
            sx={{
              alignItems: "center",
              padding: "0 8px",
              backgroundColor: "unset !important ",
              color: "#004AAD",
              border: "1px solid #004AAD",
            }}
          />
        </Link>
        {/* <Link to="/add/connectors" style={{ textDecoration: "none" }}>
          <Chip
            className={classes.menuitem}
            label="+ Connectors"
            sx={{
              alignItems: "center",
              padding: "0 8px",
              backgroundColor: "unset !important ",
              color: "#004AAD",
              border: "1px solid #004AAD",
            }}
          />
        </Link> */}
      </Stack>
    </Stack>
  );
};
const useStyles = makeStyles((theme) => ({
  menuitem: {
    ["@media (max-width:768px)"]: {
      width: "100%",
    },
  },
}));
export default ManufacturerHeading;
